/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react"

export const Footer = () => {
  return (
    <div className="footer-container">
      <div className="icons">
        <a
          href="https://www.facebook.com/luka.milanovic.3720/"
          target="_blank"
          rel="noreferrer"
          className="fa fa-facebook"
        ></a>
        <a
          href="https://www.linkedin.com/in/luka-milanovic-0a7b9b222/"
          target="_blank"
          rel="noreferrer"
          className="fa fa-linkedin"
        ></a>
        <a
          href="https://www.instagram.com/luka_m1l/"
          target="_blank"
          rel="noreferrer"
          className="fa fa-instagram"
        ></a>

        <a
          href="mailto:luka.milanovic@rocketmail.com?Subject=Some%20subject"
          target="_blank"
          rel="noreferrer"
          className="fa fa-envelope"
        ></a>

        <a
          href="https://github.com/lukamil98"
          target="_blank"
          rel="noreferrer"
          className="fa fa-github"
        ></a>
      </div>
    </div>
  )
}
